/**
 * Returns the primary isbn of the title which is stored as TitleInfo.primary_isbn in ContentByQuery data
 * @param {*} data A JS object
 */
export function getPrimaryIsbn(data) {
	return data && data.TitleInfo && data.TitleInfo.primary_isbn;
}

/**
 * Returns the unique ID of the title which is stored as TitleInfo.ui in ContentByQuery data
 * @param {*} data A JS object
 */
export function getTitleUi(data) {	
	return (data.TitleInfo && data.TitleInfo.ui) || "";
}

/**
 * Returns the main title of the title which is stored as TitleInfo.main_title in ContentByQuery data
 * @param {*} data A JS object
 */
export function getMainTitle(data) {	
	return data.TitleInfo && data.TitleInfo.main_title;
}




// WEBPACK FOOTER //
// ./src/data/TitleInfoSelector.js